import {Action} from '@ngrx/store';
import {type} from '../../shared';
import {Shipping} from '../models/shipping';

export const shippingActionTypes = {
  LOAD: type('[Shipping] Load'),
  LOAD_SUCCESS: type('[Shipping] Load Success'),
  LOAD_FAIL: type('[Shipping] Load Fail'),
  CLEAR: type('[Shipping] Clear'),
  LOAD_FAIL_GONE: type('[Shipping] Load Fail Gone'), // TODO: don't change this type because used in order-detail.component
};

export class LoadShippingAction implements Action {
  readonly type = shippingActionTypes.LOAD;
  constructor(public payload?: string) {}
}

export class LoadShippingSuccessAction implements Action {
  readonly type = shippingActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Shipping) {}
}

export class LoadShippingFailAction implements Action {
  readonly type = shippingActionTypes.LOAD_FAIL;
  constructor(public payload?: number) {}
}

export class ShippingClearAction implements Action {
  readonly type = shippingActionTypes.CLEAR;
  constructor() {}
}

export class ShippingGoneAction implements Action {
  readonly type = shippingActionTypes.LOAD_FAIL_GONE;
  constructor(public payload?: number) {}
}

